{
    "columns": [
      {
        "header_id": "filename",
        "header_label": "File Name",
        "jsonpath": "filename",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "status",
        "header_label": "Status",
        "jsonpath": "status",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "createddate",
        "header_label": "Created Date",
        "jsonpath": "createddate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "createdbyName",
        "header_label": "Created By",
        "jsonpath": "createdbyName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      }
    ],
    "buttons": [
    ],
    "apiDetails": "natpayfilelist.json",
    "pageName": "natpayfilelist",
    "orderByColumn": ["natpayfileid"],
    "orderBy": ["desc"]
  }
  